import { ServiceSessionStorageBase } from "@/services/storage/base/service-session-storage-base";
import {
  LinkDataHandler,
  LinkSongData,
  LinkSongStorageData,
} from "@/services/storage/base/storage-abstractions";
import { base64ToBlob, blobToBase64 } from "@/utils/blob-utils";

export class LinkDataStorageMixin
  extends ServiceSessionStorageBase
  implements LinkDataHandler
{
  private readonly linkFileKey = "linkFileData";

  async setLinkData(data: LinkSongData | null): Promise<void> {
    if (data === null) {
      await this.deleteDataDB(this.linkFileKey);
      return;
    }

    const base64data = await blobToBase64(data.songFile);
    const jsonData = JSON.stringify({
      title: data.title,
      image: data.image,
      songFile: base64data,
    });

    await this.saveDataDB(this.linkFileKey, jsonData);
  }

  async getLinkData(): Promise<LinkSongData | null> {
    const jsonLinkData = await this.getDataDB(this.linkFileKey);
    if (!jsonLinkData) {
      return null;
    }

    const linkData = JSON.parse(jsonLinkData) as LinkSongStorageData;
    return {
      songFile: new File([base64ToBlob(linkData.songFile)], linkData.title),
      image: linkData.image,
      title: linkData.title,
    };
  }
}
